function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "Ellipse_19",
  x: 0,
  y: 0,
  width: 30,
  height: 30,
  filterUnits: "userSpaceOnUse"
}, React.createElement("feOffset", {
  dy: 2,
  input: "SourceAlpha"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  result: "blur"
}), React.createElement("feFlood", {
  floodOpacity: 0.502
}), React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_98",
  "data-name": "Group 98",
  transform: "translate(-439 -1166)"
}, React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 439, 1166)",
  filter: "url(#Ellipse_19)"
}, React.createElement("circle", {
  className: "backdrop",
  id: "Ellipse_19-2",
  "data-name": "Ellipse 19",
  cx: 9,
  cy: 9,
  r: 9,
  transform: "translate(6 4)"
})), React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M261,3886.729a9,9,0,1,0,9,9A9,9,0,0,0,261,3886.729Zm-.425,12.889-.639.69-.612-.714-3.474-4.041,1.131-1.22,2.815,2.073,6.153-5.054,1.148,1.218Z",
  transform: "translate(193 -2716.729)"
}));

var SvgCheckmarkNocolor = function SvgCheckmarkNocolor(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCheckmarkNocolor, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark_nocolor.27f4c114.svg";
export { ForwardRef as ReactComponent };